import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/react-query";
import './styles/TemplateDocument.css';
import { initAnalytics } from "./lib/analytics";

// Initialize analytics before rendering
initAnalytics();

// Disable right click only in production
document.addEventListener('contextmenu', (e) => {
  // For Vite/React, use import.meta.env.MODE; for CRA, use process.env.NODE_ENV
  const isProd = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.MODE === 'production') ||
                 (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production');
  if (isProd) {
    e.preventDefault();
    console.log('Right click disabled');
    return false;
  }
}, false);

// Disable copy except for input elements
document.addEventListener('keydown', (e) => {
  const target = e.target as HTMLElement;
  const isInput = target.tagName === 'INPUT' || 
                  target.tagName === 'TEXTAREA' || 
                  target.getAttribute('contenteditable') === 'true';
  
  if (!isInput && (e.ctrlKey || e.metaKey) && (e.key === 'c' || e.key === 'C')) {
    e.preventDefault();
    return false;
  }
});

// Disable text selection except for input elements
document.addEventListener('selectstart', (e) => {
  const target = e.target as HTMLElement;
  const isInput = target.tagName === 'INPUT' || 
                  target.tagName === 'TEXTAREA' || 
                  target.getAttribute('contenteditable') === 'true';
  
  if (!isInput) {
    e.preventDefault();
    console.log('Text selection disabled');
    return false;
  }
});

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>
);